import { render, staticRenderFns } from "./ScreenShot.vue?vue&type=template&id=cca43e94"
import script from "./ScreenShot.vue?vue&type=script&lang=js"
export * from "./ScreenShot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cca43e94')) {
      api.createRecord('cca43e94', component.options)
    } else {
      api.reload('cca43e94', component.options)
    }
    module.hot.accept("./ScreenShot.vue?vue&type=template&id=cca43e94", function () {
      api.rerender('cca43e94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ScreenShot.vue"
export default component.exports